import React from 'react';

export const ArrowLeft = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--arrow-left';
  color = color || '#0076CC';

  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M8 15L1 8M1 8L8 1M1 8L19 8"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowLeft;
